
import Vue from "vue";
import { Component, Prop, Emit } from "vue-property-decorator";

@Component
export default class TagPicker extends Vue {
  @Prop({ type: Array, default: () => [] }) readonly value!: string[];
  @Prop({ type: Array, default: () => [] }) readonly apiTags!: string[];
  @Prop({ type: Object, default: () => ({}) }) readonly tagColours!: Record<string, string>;

  search = "";
  suggestions: string[] = [];
  showSuggestions = false;
  highlightedIndex: number | null = null;

  get mappedColours(): Record<string, string> {
    return Object.fromEntries(this.value.map((tag) => [tag, this.tagColours[tag] || "#5c5e6459"]));
  }

  get modelValue(): string[] {
    return this.value;
  }

  set modelValue(val: string[]) {
    this.emitInput(val);
  }

  @Emit("input")
  emitInput(val: string[]) {
    return val;
  }

  @Emit("click-tag")
  clickTag(tag: string): string {
    return tag;
  }

  get filteredSuggestions(): string[] {
    const lowerSearch = this.search.toLowerCase();
    return this.suggestions.filter((tag) => tag.toLowerCase().includes(lowerSearch) && !this.modelValue.includes(tag)).slice(0, 5);
  }

  fetchSuggestions(): void {
    this.suggestions = this.apiTags;
    this.showSuggestions = this.filteredSuggestions.length > 0;
  }

  handleKeyDown(event: KeyboardEvent): void {
    if (!this.showSuggestions || this.filteredSuggestions.length === 0) return;

    if (event.key === "ArrowDown") {
      event.preventDefault();
      if (this.highlightedIndex === null || this.highlightedIndex >= this.filteredSuggestions.length - 1) {
        this.highlightedIndex = 0;
      } else {
        this.highlightedIndex += 1;
      }
    } else if (event.key === "ArrowUp") {
      event.preventDefault();
      if (this.highlightedIndex === null || this.highlightedIndex <= 0) {
        this.highlightedIndex = this.filteredSuggestions.length - 1;
      } else {
        this.highlightedIndex -= 1;
      }
    } else if (event.key === "Enter") {
      if (this.highlightedIndex !== null && this.filteredSuggestions[this.highlightedIndex]) {
        this.addSuggestion(this.filteredSuggestions[this.highlightedIndex]);
        event.preventDefault();
      } else {
        this.addTag();
      }
    }
  }

  validateTag(tag: string): boolean {
    if (tag && tag.length > 0) {
      return true;
    }
    return false;
  }

  addTag(): void {
    const tag = this.search.trim();
    const match = this.filteredSuggestions.find((t) => t.toLowerCase() === tag.toLowerCase());

    if (!match && tag && !this.modelValue.includes(tag)) {
      this.modelValue = [...this.modelValue, tag];
    }

    this.clearInput();
  }

  addSuggestion(tag: string): void {
    if (!this.modelValue.includes(tag)) {
      this.modelValue = [...this.modelValue, tag];
    }
    this.clearInput();
  }

  removeTag(index: number): void {
    const newTags = [...this.modelValue];
    newTags.splice(index, 1);
    this.modelValue = newTags;
  }

  clearInput(): void {
    this.search = "";
    this.showSuggestions = false;
    this.highlightedIndex = null;
  }

  onInput(tags: string[]): void {
    this.modelValue = tags;
  }

  onTagState(): void {
    // Add custom tag validation feedback
  }

  onFocus() {
    this.showSuggestions = this.filteredSuggestions.length > 0;
  }

  onBlur() {
    // Delay hiding to allow click on suggestion
    setTimeout(() => {
      this.showSuggestions = false;
    }, 150);
  }
}
